import { createSelector } from 'reselect'
import { pagesSelector } from '../../../selectors'

export const reallocationsPageSelector = createSelector(pagesSelector, ({ reallocationsPage }) => reallocationsPage)
